import { throwIfAborted } from '../abort.js';
import { FundingConnectionError } from '../customer/connection-error.js';
import { readFundingConnection } from '../discovery/connection.js';
import { FundingProviderError } from '../provider-error.js';
/** A silent credentials check does not open authentication, quote or payment frames. */
export async function discoverDirectPurchaseMethods(provider, signal) {
    throwIfAborted(signal);
    const connection = await readFundingConnection(provider, signal);
    throwIfAborted(signal);
    if (!connection.ok)
        throw new FundingConnectionError(connection.error);
    const response = await provider.getPaymentMethods({ currency: 'USD' });
    throwIfAborted(signal);
    if (!response.ok)
        throw new FundingProviderError(response.error);
    const configs = response.value.data.paymentMethodConfigs ?? [];
    return ['apple_pay', 'google_pay', 'card'].filter((method) => {
        const config = configs.find((value) => value.type === method);
        return (config?.availability.active &&
            !config.capabilities.requiresWidget &&
            config.capabilities.supportedCurrencies.includes('USD') &&
            config.capabilities.supportedTransactionTypes.includes('buy'));
    });
}
